import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../config';
import { roomDTO } from '../models/RoomDTO.model';
import { VideoCallStadisticsModel } from '../models/VideoCallStadistics.model';
import { Observable } from 'rxjs';
import { UploadConsentBody } from '../types/UploadConsentBody';
import { Params } from '../types/Params';
import { TokboxCredentials } from '../types/TokboxCredentials';

@Injectable({
  providedIn: 'root',
})
export class VideoconsultaBackendService {
  constructor(private httpClient: HttpClient) {}

  // Endpoints generales
  checkCid(conferenceId: number) {
    return this.httpClient.get(
      `${Config.baseURL}${Config.videoConsultaEndpoints.cid}/${conferenceId}`,
      { responseType: 'text', observe: 'response', reportProgress: true }
    );
  }

  getTokboxCredentials( conferenceId: number, isMedic: number, roomDTO: roomDTO ): Observable<TokboxCredentials> {
    return this.httpClient.post<TokboxCredentials>(
      `${Config.baseURL}${Config.videoConsultaEndpoints.room}${ isMedic ? 'medic' : 'partner' }/${conferenceId}`,
      roomDTO,
      { reportProgress: true }
    );
  }

  blacklistCid(conferenceId: number) {
    return this.httpClient.post(
      `${Config.baseURL}${Config.videoConsultaEndpoints.cid}`,
      { cid: conferenceId },
      { observe: 'response' }
    );
  }

  // Endpoints de estadisticas - START
  statsVc(videoCallStatsDTO: VideoCallStadisticsModel, isMedic: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.post(
      Config.baseURL + Config.easyDocEndpoints.statsvc + `${isMedic}`,
      videoCallStatsDTO,
      { ...httpOptions, responseType: 'text' }
    );
  }

  statsVcFinalized(
    videoCallStatsDTO: VideoCallStadisticsModel,
    isMedic: string
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.post(
      Config.baseURL +
        Config.easyDocEndpoints.finalizedVideoCall +
        `${isMedic}`,
      videoCallStatsDTO,
      httpOptions
    );
  }

  statsByCid(cid: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.get(
      Config.baseURL + Config.easyDocEndpoints.statsBycid + cid,
      httpOptions
    );
  }
  // Endpoints de estadisticas - END

  public sendMedicEmail(cid: number, email: string): Observable<string> {
    const body = {
      conferenceId: cid,
      email,
    };

    return this.httpClient.post(
      `${Config.baseURL}${Config.easyDocEndpoints.sendMedicEmail}`,
      body,
      {
        responseType: 'text',
      }
    );
  }

  public recordVC(cid: number): Observable<string> {
    return this.httpClient.post(
      `${Config.baseURL}${Config.easyDocEndpoints.recordVC}`,
      { cid },
      { responseType: 'text' }
    );
  }

  public sendConsentRecording(
    cid: number,
    consent: boolean
  ): Observable<string> {
    const body = { cid, consent };

    return this.httpClient.post(
      `${Config.baseURL}${Config.easyDocEndpoints.consentRecording}`,
      body,
      { responseType: 'text' }
    );
  }

  public medicIsConnected(
    cid: number
  ): Observable<{ enter: boolean; message: string }> {
    return this.httpClient.post<{ enter: boolean; message: string }>(
      `${Config.baseURL}${Config.easyDocEndpoints.memberCanEnter}`,
      { cid },
      { responseType: 'json' }
    );
  }

  public uploadConsentSelection(body: UploadConsentBody): Observable<string> {
    return this.httpClient.post(
      `${Config.baseURL}${Config.easyDocEndpoints.uploadConsentSelection}`,
      body,
      { responseType: 'text' }
    );
  }

  public showConsentMessage(cid: number): Observable<any> {
    return this.httpClient.get(
      `${Config.baseURL}${Config.easyDocEndpoints.showConsent}/${cid}`,
      { responseType: 'json' }
    );
  }

  public sendPayload(payload: string): Observable<Params> {
    return this.httpClient.post<Params>(
      `${Config.baseURL}${Config.easyDocEndpoints.sendPayload}`,
      {
        params: payload,
      }
    );
  }

  public sendMedicStatus(cid: number): Observable<string> {
    return this.httpClient.post(
      `${Config.baseURL}${Config.easyDocEndpoints.sendMedicStatus}`,
      { cid },
      { responseType: 'text' }
    )
  }
}
